import React, { Fragment } from 'react';
import _ from 'lodash';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';

const CardFilter = ({
  columns,
  init,
}) => {
  return (
    <Fragment>
      <div className='filter card-filter'>
        <button className='search-filter'>
          <FontAwesomeIcon icon={faSearch}/>
        </button>
        {columns.map((column, index) => (
          <input
            key={index}
            className={column.size || ''}
            placeholder={column.placeholder}
            value={column.value}
            onChange={e => column.action(_.set({}, column.key, e.target.value))}
          />
        ))}
        <button className='init-filter' onClick={() => init()}>
          <FontAwesomeIcon icon={faTimes} style={{paddingRight:'3px'}}/>
        </button>
      </div>
    </Fragment>
  );
};

export default CardFilter;